/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Card_Upgrade_TeamInputs */



/**
* | output |
* | --- |
* | "Upgrade to Team" |
*
* @param {Plan_Card_Upgrade_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_upgrade_team = /** @type {((inputs?: Plan_Card_Upgrade_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Upgrade_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf Team upgraden")
	return /** @type {LocalizedString} */ ("Upgrade to Team")
});